import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map } from 'rxjs';
import { AuthActions } from '../auth/auth.actions';
import { ReminderActions } from './reminder.actions';

/**
 * @description Reminder Effects.
 * @exports
 * @class ReminderEffects
 */
@Injectable()
export class ReminderEffects {
  private readonly actions = inject(Actions);

  readonly onSwitchProfile_Logout = createEffect(
    () => {
      return this.actions.pipe(
        ofType(AuthActions.switchProfile, AuthActions.logout),
        map(() => ReminderActions.reset())
      );
    },
    { dispatch: true }
  );
}
